import { makeAutoObservable } from 'mobx'

import dataList from './data'

class ListStore {
    listData = dataList
    constructor() {
        makeAutoObservable(this)
    }
    getList = () => {
        return this.listData
    }
}

export default ListStore
